import { format as dateFnsFormat } from 'date-fns'
import { deburr, lowerCase } from 'lodash'

export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export const formatDate = (date, format) => {
  if (!date) {
    return ''
  }

  if (!format) {
    format = 'dd/MM/yyyy HH:mm'
  }
  return dateFnsFormat(new Date(date), format)
}

export const formatAmount = value => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

export const parseFilters = filters => {
  const result = {}

  for (const key of Object.keys(filters)) {
    if (filters[key]) {
      result[key] = filters[key]
    }
  }

  return result
}

export const slugify = text => {
  return deburr(lowerCase(text))
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
}
